import React, { useState } from 'react'
import { type RootState } from '../../store'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import BackButton from '../../components/BackButton'
import LanguageStrings from '../../i18n/locales'
import HistoryBarGraph from './components/HistoryBarGraph'
import dayjs, { type Dayjs } from 'dayjs'
import './KpiDetails.css'
import { type ToggleOption } from '../../components/GenericToggleButton'
import HistoryTable from './components/KpiComponents/HistoryTable'
import { getToggleOptions } from './components/KpiComponents/kpiUtils'
import { doesKpiHaveDonutChart } from './redux/changeKpiType'
import HistoryDonutKpiBarGraph from './components/HistoryDonutKpiBarGraph'

const KpiDetailsStrings = LanguageStrings().AMIDataCollectionStrings.KpiDetails

const defaultDate = {
  end: dayjs(new Date()),
  start: dayjs(new Date((new Date()).setMonth(new Date().getMonth() - 1)))
}

const KpiDetails = (): JSX.Element => {
  const navigate = useNavigate()
  const selectedKpi = useSelector((state: RootState) => state.kpiType)
  const [selectedDonut, setSelectedDonut] = useState<number>(0)
  const [selectedBar, setSelectedBar] = useState<ToggleOption>(getToggleOptions(selectedKpi)[0])
  const [selectedDate, setSelectedDate] = useState<Dayjs>(defaultDate.end)
  const [startDate, setStartDate] = useState<Dayjs>(defaultDate.start)
  const [endDate, setEndDate] = useState<Dayjs>(defaultDate.end)

  return (
    <div>
      <div className='link-breadcrumb'>
        <span data-testid='assetManagementbreadcrumb' onClick={ () => { navigate('/isense') }} className='assetmgmtli'>{KpiDetailsStrings.Honeywell_Heading_Breadcrumb}</span>
        <span style={{ padding: '0 0.5em' }}>/</span>
        <span>{selectedKpi}</span>
      </div>
      <div className='topUtilityBar'>
        <BackButton/>
        <span id='componentTitle' data-testid='kpi-details'>{selectedKpi}</span>
      </div>
      <div>
        {
          doesKpiHaveDonutChart(selectedKpi)
            ? <HistoryDonutKpiBarGraph selectedDonut={selectedDonut} setSelectedDonut={setSelectedDonut} selectedBar={selectedBar} setSelectedBar={setSelectedBar} setSelectedDate={setSelectedDate} startDate={startDate} endDate={endDate} setStartDate={setStartDate} setEndDate={setEndDate} />
            : <HistoryBarGraph selectedBar={selectedBar} setSelectedBar={setSelectedBar} setSelectedDate={setSelectedDate} startDate={startDate} endDate={endDate} setStartDate={setStartDate} setEndDate={setEndDate} />
        }
      </div>
      <div style={{ backgroundColor: '#272727', border: '1px solid black', borderBottomLeftRadius: 10, borderBottomRightRadius: 10, marginBottom: 10 }}>
        <HistoryTable selectedDonut={selectedDonut} selectedBar={selectedBar} setSelectedBar={setSelectedBar} selectedDate={selectedDate} />
      </div>
    </div>
  )
}

export default KpiDetails
